import { ComponentThemeProps } from "@insite/mobius/globals/baseTheme";

const LayoutTablePresentationPropsDefault: ComponentThemeProps["layoutTable"]["defaultProps"] = {};

export default LayoutTablePresentationPropsDefault;
